<template>
  <pm-categories  v-if="schedulesFetched" :idxSchedule="0" />
</template>

<script>
import CategoriesDesktop from './CategoriesDesktop'
import { scheduleMixin } from '../utils/scheduleMixin'

export default {
  name: 'SchedulesDesktop',
  mixins: [scheduleMixin],
  components: {
    pmCategories: CategoriesDesktop
  }
}
</script>
